import { HostListener, Input } from '@angular/core';

export abstract class HoverActionDirective {

    private hoverTimeout: ReturnType<typeof setTimeout>;

    @Input('hoverDelay') public hoverDelay: number = 100;

    constructor(
        private readonly action: () => void
    ) {}

    @HostListener('mouseenter')
    public onMouseEnter() {
        if (this.enabled()) {
            this.hoverTimeout = setTimeout(() => {
                this.action();
            }, this.hoverDelay);
        }
    }

    @HostListener('mouseleave')
    public onMouseLeave() {
        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = null;
        }
    }

    protected abstract enabled(): boolean;
}
